import { SUB_MENU_TYPE } from "../constants";

export const setSubMenu = (menus = []) =>
   async (dispatch) => {
      dispatch({
         type: SUB_MENU_TYPE.SET,
         payload: menus
      })
   };